import { BaseURl } from "./BaseApiUrl";

// /https://testcockpit.p2k.in/api/WoDetails/getPendingWoList/v1/?userUUID=1d33299f-f015-11ee-91f2-b8ca3ad15bed&startDate=07/09/2025&endDate=10/09/2025
export const getPendingWorkOrderListAPIURL = BaseURl + "WoDetails/getPendingWoList/v1/";

// /https://testcockpit.p2k.in/api/WoDetails/getCompletedWoList/v1/?userUUID=1d33299f-f015-11ee-91f2-b8ca3ad15bed&startDate=07/09/2025&endDate=10/09/2025
export const getCompletedWorkOrderListAPIURL = BaseURl + "WoDetails/getCompletedWoList/v1/";


//https://testcockpit.p2k.in/api/WoDetails/getSchedulerUserList/v1/?userUUID=11efb78d-aaff-58de-9d30-22f17ecb52c5&woUUID=11f08d8e-609b-cb63-a6ea-22f17ecb52c5&isPagination=0&pageNo=0&perPageRec=0
export const getSchedularUserListAPIURL = BaseURl + "WoDetails/getSchedulerUserList/v1/";

//https://testcockpit.p2k.in/api/WoDetails/changeWoScheduler/v1/
export const updateSchedularUserListAPIURL = BaseURl + "WoDetails/changeWoScheduler/v1/";



//https://testcockpit.p2k.in/api/WoDetails/getFieldExecutiveList/v1/?userUUID=11efb78d-aaff-58de-9d30-22f17ecb52c5&woUUID=11f08d8e-609b-cb63-a6ea-22f17ecb52c5&woSchedulerUUID=721fb220-49be-11ef-bab4-22f17ecb52c5&isPagination=0&pageNo=0&perPageRec=0
export const getFieldExecutiveListBySchedularAPIURL = BaseURl + "WoDetails/getFieldExecutiveList/v1/";

//https://testcockpit.p2k.in/api/WoDetails/changeWoFieldExecutive/v1/
export const updateFieldExecutiveListAPIURL = BaseURl + "WoDetails/changeWoFieldExecutive/v1/";




//https://testcockpit.p2k.in/api/WoDetails/getWoStatusList/v1/?userUUID=11efb78d-aaff-58de-9d30-22f17ecb52c5&woUUID=11f08d8e-609b-cb63-a6ea-22f17ecb52c5
export const getWorkOrderListAPIURL = BaseURl + "WoDetails/getWoStatusList/v1/";

//https://testcockpit.p2k.in/api/WoDetails/changeWoStatus/v1/
export const updateWorkOrderListAPIURL = BaseURl + "WoDetails/changeWoStatus/v1/";



//https://testcockpit.p2k.in/api/WoDetails/getPaymentModeList/v1/?userUUID=11efb78d-aaff-58de-9d30-22f17ecb52c5
export const getPaymentModeListAPIURL = BaseURl + "WoDetails/getPaymentModeList/v1/";

//https://testcockpit.p2k.in/api/WoDetails/changeWoPaymentMode/v1/
export const updatePaymentModeAndReceivedAmtAPIURL = BaseURl + "WoDetails/changeWoPaymentMode/v1/";


//Work Order Details API
//https://testcockpit.p2k.in/api/WoDetails/getWoInformation/v1/?userUUID=1d33299f-f015-11ee-91f2-b8ca3ad15bed&exeUUID=11f0a66d-0935-dd2a-8df4-22f17ecb52c5&woUUID="-"
export const getWorkOrderDetailsAPIURL = BaseURl + "WoDetails/getWoInformation/v1/";

// https://testcockpit.p2k.in/api/WoDetails/reasonTemplates/v1/11ef347b-4f1b-3602-862c-b8ca3ad15bed?isPagination=0&pageNo=0&perPageRec=0
export const getExecutionRescheduleReasonAPIURL = BaseURl + "WoDetails/reasonTemplates/v1/";


export const patchRescheduleWOExecutionAPIURL = BaseURl + "WoDetails/rescheduleWOExecution/v1/";


export const patchCancelWorkOrderAPIURL = BaseURl + "WoDetails/cancelCockpitWorkOrder/v1/";